<template>
  <div class="program-list-item">
    <div class="item-cover-container"
         @click.stop="handleClickCover(item, index)"
    >
      <ym-cover :cover="item.cover"
                :alt="item.title"
                :type="coverType"
                :lazy="lazy"
      />
      <template>
        <ym-loading v-if="playingCurrent && loading"
                    class="player-spinner play-control-icon"
                    type="fading-circle"
                    :size="16"
        />
        <ym-icon v-else
                 class="play-control-icon"
                 :name="playingCurrent ? 'round-pause-fill': 'round-play-fill'"
        />
      </template>
    </div>
    <div class="item-content"
         @click="handleClickContent(item)"
    >
      <h5 class="item-title ym-two-line-ellipsis"
          :class="{ 'is-active': item.playStatus === 'played' }"
      >
        <video-tag v-if="item.mediaType === 'mp4'"
                   class="video-tag"
        />
        <span v-if="item.showSeq > 0">第{{ item.showSeq }}讲：</span><span v-html="item.title"></span>
      </h5>
      <div v-if="listType === 'search' && item.summary && item.summary !== ''"
           class="item-summary ym-line-ellipsis"
           v-html="item.summary"
      ></div>
      <div v-if="showAudioTitle"
           class="audio-title"
      >
        {{ item.audioTitle }}
      </div>
      <div class="item-bottom">
        <div class="item-desc"
             :class="{ 'search-desc': listType === 'search' }"
        >
          {{ item.desc }}
        </div>
        <template v-if="!showAudioTitle"
        >
          <ym-tag v-if="showFreeLabel"
                  type="primary-light"
                  :border="false"
                  round
          >
            免费试听
          </ym-tag>
          <ym-tag v-if="showPlayStatusLabel"
                  :type="item.playStatus | playStatusTypeFilter"
                  :plain="item.playStatus === 'played'"
                  :border="false"
          >
            {{ item.playStatus | playStatusTextFilter }}
          </ym-tag>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { Loading, Tag } from '@ymba/ym-ui';
  import { decorator, before } from 'ym-reporter-vue';
  import YmCover from '@/components/ProductCover';
  import VideoTag from '@/pages/VideoProgram/components/VideoProgramTag';

  export default {
    name: 'ProgramListItem',
    components: {
      'ym-loading': Loading,
      YmTag: Tag,
      YmCover,
      VideoTag,
    },
    props: {
      hideIcon: {
        type: Boolean,
        default: false,
      },
      audioType: {
        type: String,
        required: true,
      },
      playingId: {
        type: Number,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
      lazy: {
        type: Boolean,
        default: true,
      },
      showAudioTitle: {
        type: Boolean,
        default: false,
      },
      listType: {
        type: String,
        default: 'program',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      recordType: {
        type: String,
      },
    },
    filters: {
      playStatusTextFilter(status) {
        switch (status) {
          case 'playing': {
            return '未学完';
          }
          case 'played': {
            return '已学完';
          }
          case 'unPlay': {
            return '待学习';
          }
          default: {
            return '';
          }
        }
      },
      playStatusTypeFilter(status) {
        switch (status) {
          case 'playing': {
            return 'warning';
          }
          case 'played': {
            return 'disabled';
          }
          case 'unPlay': {
            return 'highlight-light';
          }
          default: {
            return '';
          }
        }
      },
    },
    computed: {
      playingCurrent() {
        const { playingId, item } = this;
        return playingId === item.id;
      },
      coverType() {
        if (this.listType === 'program') {
          return this.audioType === 'book' ? 'small-vertical-rect' : 'normal-small-square';
        }
        return 'normal-square';
      },
      checkIsMember() {
        const { item } = this;
        const { joinStatus } = item;
        if (joinStatus == null) return false;
        return joinStatus === 'member' || joinStatus === 'vipMember';
      },
      showFreeLabel() {
        const { item, checkIsMember } = this;
        const { trialLength } = item;
        if (trialLength == null) return false;
        return !checkIsMember && trialLength === -1;
      },
      showPlayStatusLabel() {
        const { item, checkIsMember } = this;
        const { playStatus } = item;
        if (playStatus == null) return false;
        return checkIsMember && playStatus !== '';
      },
      recordName() {
        if (this.recordType === 'learning') return 'LEARNING_AUDIO_PLAY_CLICK';
        return '';
      },
    },
    methods: {
      @decorator(before(function (item) {
        this.$reporter.report(this.recordName, item);
      }))
      handleClickCover(item) {
        this.$emit('click-cover', item);
      },
      handleClickContent(item) {
        this.$emit('click-content', item);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .program-list-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: @size-base 0;
  }

  .item-cover-container {
    display: inline-block;
    position: relative;
    margin-right: @size-base;
    flex-shrink: 0;
  }

  .play-control-icon {
    font-size: @course-content-icon-size;
    color: @color-white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @player-spinner-size: (@course-content-icon-size - 8);
  .player-spinner {
    width: @player-spinner-size;
    height: @player-spinner-size;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid @color-white;
    border-radius: @border-radius-round;
    background-color: rgba(0, 0, 0, .4);
  }

  .item-content {
    align-self: stretch;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: @product-list-title-padding-top;
  }

  .item-title {
    margin: 0;
    line-height: 1.4;
    color: @color-text-base;
    font-size: @font-size-base;
    &.is-active {
      color: @color-text-lighter;
    }
    /deep/ .highlight {
      color: @color-text-primary;
    }
  }

  .item-summary {
    font-size: @font-size-extra-small;
    color: @color-text-lighter;
    /deep/ .highlight {
      color: @color-text-primary;
    }
  }

  .item-bottom {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    color: @color-text-lighter;
    font-size: @font-size-small;
  }

  .item-desc {
    line-height: 1;
    font-size: @font-size-extra-small;
    &.search-desc {
      font-size: @font-size-extra-small;
    }
  }

  .audio-title {
    color: @color-text-lighter;
    font-size: @font-size-extra-small;
  }

  .video-tag {
    margin-right: @size-extra-small;
  }
</style>
